export default "__VITE_ASSET__8IVTUHp$__"